module.exports = __webpack_public_path__ + "static/img/p3.76065f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/20250903/szr/p3.png
// module id = uzOp
// module chunks = 0